$(document).on('show.bs.collapse', '.collapse', function(){
  var headingId = $(this).attr('aria-labelledby');

  $('#' + headingId + ' i').removeClass('fa-plus-circle').addClass('fa-minus-circle')
});

$(document).on('hide.bs.collapse', '.collapse', function(){
  var headingId = $(this).attr('aria-labelledby');

  $('#' + headingId + ' i').removeClass('fa-minus-circle').addClass('fa-plus-circle')
});